import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { getData, useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    updatePhoneNumberContext,
    updatePhoneNumberContextError,
    updatePhoneNumberContextReset,
    updatePhoneNumberContextSuccess,
} from '@perpay-web/fintech/actions/entities/phoneNumber';
import { UPDATE_AND_VERIFY_PHONE_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

export const getPhoneAccount = (state) => getData(state);

const useUpdatePhoneNumberDataModule = () => {
    const dataModule = useDataModule((payload) =>
        authenticatedJsonFetch(
            `${UPDATE_AND_VERIFY_PHONE_ENDPOINT}`,
            { mobile_phone: payload },
            HTTPMethod.post,
        ),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: updatePhoneNumberContext,
        error: updatePhoneNumberContextError,
        success: updatePhoneNumberContextSuccess,
        reset: updatePhoneNumberContextReset,
    });

    return dataModule;
};

const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useUpdatePhoneNumberDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseUpdateUserPhoneDataModuleProvider,
    useUpdatePhoneNumberContext,
] = createContextProvider(providerFactory);
